module.exports = __webpack_public_path__ + "img/pencil2.b0753817.svg";